/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class LassoAPI
 * @hideconstructor
 * @classdesc API class that is used to obtain the list of lasso views avaiable
 */
define([], () => {
	class LassoAPI {

		/**
		 * @function LassoAPI#registerProvider
		 * @description Register a provider as a lasso view provider
		 * @param {provider} provider Lasso view provider to contribute
		 */
		registerProvider(/* provider */) {}

		/**
		 * @function LassoAPI#getContributions
		 * @description Returns a list of lasso contributions
		 * @return {Object[]} List of contributions
		 */
		getContributions() {}

		/**
		 * @function LassoAPI#toggleLassoSelect
		 * @description Toggle the state (on/off) of the lasso mode
		 * @param {string} lassoViewId view id of the lasso view (Lasso views can be retangle, circle, polygon, etc)
		 */
		toggleLassoSelect(/*lassoViewId */){}

		/**
		 * @description Registers a visualization event handler.
		 * @function VisualizationAPI#on
		 * @private
		 *
		 * @param {String} name Event name
		 * @param {Function} name Event handler
		 * @return Object that has a remove function that removes the event handler.
		 */
		on() {}

		/**
		 * @description Deregisters a visualization event handler.
		 * @function VisualizationAPI#off
		 * @private
		 *
		 * @param {String} name Event name
		 * @param {Function} name Event handler
		 *
		 */
		off() {}
	}

	return LassoAPI;
});